import type { DataSource, Entity, MaritimeEntity } from '../types/entity';
import { apiFetch } from '../lib/apiFetch';

/**
 * Client nunca fala com aisstream.io diretamente — sempre via
 * `/api/maritime`. Isto é ainda mais estrito que FIRMS/N2YO: mesmo
 * ignorando a questão da key, aisstream é WebSocket, e o padrão de
 * fetch de camada usado no resto do projeto é request/response. Quem
 * mantém a conexão WS viva é o ingestor de fundo (ver
 * functions/src/proxies/aisstreamIngestor.ts); este client só lê o
 * cache já materializado via HTTP GET normal.
 */

interface MaritimeProxyContact {
  mmsi: number;
  shipName: string | null;
  lat: number;
  lon: number;
  speedKn: number | null;
  observedAt: string;
}

interface MaritimeProxyResponse {
  contacts: MaritimeProxyContact[];
}

function toMaritimeEntity(c: MaritimeProxyContact): MaritimeEntity {
  return {
    id: `maritime-${c.mmsi}`,
    layer: 'maritime',
    lat: c.lat,
    lon: c.lon,
    label: c.shipName ?? `MMSI ${c.mmsi}`,
    severity: 'normal',
    observedAt: c.observedAt,
    raw: {
      mmsi: c.mmsi,
      shipName: c.shipName,
      speedKn: c.speedKn,
      shipType: null, // não disponível no PositionReport, só em ShipStaticData
    },
  };
}

export const maritimeSource: DataSource = {
  layer: 'maritime',
  label: 'Marítimo (aisstream.io)',
  requiresClientKey: false,
  viaCloudFunction: true,

  async fetchEntities(): Promise<Entity[]> {
    const res = await apiFetch('/maritime');
    if (!res.ok) {
      throw new Error(`Proxy maritime respondeu ${res.status}`);
    }

    const data = (await res.json()) as MaritimeProxyResponse;
    return data.contacts.map(toMaritimeEntity);
  },
};
